import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function BonusSection() {
  return <section className="w-full bg-plum-deep" data-id="element-100" data-mp="2trfwol7jfdoj">
      <div className="mx-auto w-full max-w-content px-5 py-14 sm:px-8 sm:py-20" data-id="element-101" data-mp="2tshhvii9pgjz">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-102" data-mp="2yppt0z500kbq">
          Gratis con il tuo ordine
        </p>
        <h2 className="mt-3 text-balance text-center font-display text-[29px] font-black leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl" data-id="element-103" data-mp="3mi6n6820g2re">
          Inoltre riceverai gratuitamente questi 5 bonus esclusivi
        </h2>

        <div className="-mx-3 mt-9 grid gap-5 sm:mx-0 lg:grid-cols-2 lg:gap-6" data-id="element-104" data-mp="3hpdexa7c2cak">
          {bonuses.map(bonus => <article key={bonus.tag} className="flex flex-col overflow-hidden rounded-3xl bg-white/[0.06] ring-1 ring-white/10" data-id="element-105" data-mp="991zts2vaaif">
              <div className="w-full bg-white px-2 pb-1 pt-3 sm:px-4 sm:pt-5" data-id="element-106" data-mp="380anu2ge62w0">
                <img src={bonus.image} alt={`Mockup di ${bonus.title}`} className="w-full" width={1256} height={1256} loading="lazy" data-id="element-107" data-mp="37y6nfuhpbm0h" />
              </div>

              <div className="flex flex-1 flex-col p-5 sm:p-7" data-id="element-108" data-mp="3cxt0o3xj529a">
              <div className="flex items-center gap-2.5" data-id="element-109" data-mp="3qq959962x8cb">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gold" data-id="element-110" data-mp="3qsvdlb0snrvl">
                  <GiftIcon className="h-4 w-4 text-plum-deep" aria-hidden="true" data-id="element-111" data-mp="3lu1yje5uzstb" />
                </span>
                <span className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-gold" data-id="element-112" data-mp="4h7vyzbxkvbz">
                  {bonus.tag}
                </span>
              </div>

              <h3 className="mt-4 font-display text-[20px] font-black leading-tight text-white sm:text-[22px]" data-id="element-113" data-mp="26b79zsgftqsd">
                {bonus.title}
              </h3>
              <p className="mt-3 text-[15px] font-medium leading-snug text-white/80 sm:text-base" data-id="element-114" data-mp="2r0ro4n7l8hg4">
                {bonus.lead}
              </p>
              <p className="mt-2.5 text-[14.5px] leading-relaxed text-white/60" data-id="element-115" data-mp="2v3nzbsustba1">{bonus.body}</p>

              {bonus.items.length > 0 ? <ul className="mt-4 flex flex-wrap gap-2" data-id="element-116" data-mp="350ajsgj7q0bj">
                  {bonus.items.map(item => <li key={item} className="rounded-full bg-white/10 px-3 py-1.5 text-[12.5px] font-semibold text-white/85" data-id="element-117" data-mp="39znetok8mdp7">
                      {item}
                    </li>)}
                </ul> : null}

              <p className="mt-auto pt-6 text-[11.5px] font-extrabold uppercase tracking-[0.14em] text-white/45" data-id="element-118" data-mp="3np7eummfowut">
                Valore commerciale:{' '}
                <span className="text-gold" data-id="element-119" data-mp="1j22bxsed2hc">{bonus.value}</span>
              </p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-120" data-mp="1m1uqpcij8h33">
          <CTAButton label="Voglio i miei 5 bonus gratuiti" variant="teal" data-id="element-121" data-mp="1h1zyn5n0tlgg" />
          <p className="mt-3 text-center text-[13px] font-medium text-white/55 sm:text-sm" data-id="element-122" data-mp="1h42zkkppoyzy">
            295 € di bonus inclusi senza alcun costo aggiuntivo
          </p>
        </div>
      </div>
    </section>;
}